<script>
  import { HelpCircle } from '../lib/icons/index.js';
  import { tick } from 'svelte';
  import { t } from '../i18n/index.js';

  // Accessible inline "what is this?" hint. Pass either a glossary key
  // (term="codiceDestinatario") or raw text (text="...").
  export let term = '';
  export let text = '';

  let open = false;
  let pop;
  let shift = 0;
  $: content = text || (term ? $t(`glossary.${term}`, undefined, '') : '');

  // The bubble opens to the right of its button; near the right edge of a
  // phone that would run off screen, so it is pulled back inside, 8px clear.
  async function place() {
    shift = 0;
    await tick();
    if (!pop) return;
    const rect = pop.getBoundingClientRect();
    const overRight = rect.right - (window.innerWidth - 8);
    if (overRight > 0) shift = -Math.min(overRight, Math.max(0, rect.left - 8));
  }

  function toggle(e) {
    e.preventDefault();
    e.stopPropagation();
    open = !open;
    if (open) place();
  }
</script>

{#if content}
  <span class="info-hint-wrap">
    <button
      type="button"
      class="info-hint"
      aria-label={content}
      aria-expanded={open}
      title={content}
      on:click={toggle}
      on:blur={() => (open = false)}
    >
      <HelpCircle size={14} />
    </button>
    {#if open}
      <span role="tooltip" class="info-hint-pop" bind:this={pop}
        style={shift ? `transform: translateX(${shift}px)` : null}>{content}</span>
    {/if}
  </span>
{/if}
